/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useArg } from 'solis/navigation';

import Args from 'solis/claude/action/args';

import BoardFrontierType from 'solis/logic/board/frontier.type';
import BoardProximity from 'solis/logic/board/proximity';
import ZoneUsers from 'solis/logic/board/zone/users';


// The board is operated as one of the current account's attached colonies. Candidates
// are the board colonies whose origin user is the current account.
export const getSourceCandidates = (board, account) =>
{
  return board.getColonies().values().filter(colony => colony.cass.user === account.cass.id);
};


// The first candidate that can reach the zone, falling back to the first candidate;
// null when there are none or no zone is given.
export const getMatchingSourceColony = (board, account, zone) =>
{
  const candidates = getSourceCandidates(board, account);

  if (zone === null)
  {
    return candidates[0] ?? null;
  }

  const proximity = new BoardProximity(board, BoardFrontierType.Zone);

  return candidates.find(colony => new ZoneUsers(zone).isNeighborAccessible(proximity, colony.cass.id)) ?? candidates[0] ?? null;
};


// Resolves the `sourceColony` nav arg to a board colony, defaulting to the first
// candidate (auto-selected when there is only one) and null when there are none.
export default (board, account) =>
{
  const candidates = getSourceCandidates(board, account);

  const id = useArg(Args.SourceColony);

  return candidates.find(colony => colony.cass.id === id) ?? candidates[0] ?? null;
};
